import React, { Component } from 'react'
import Page from '../containers/Page'
import PropTypes from 'prop-types'

class ErrorsHandler extends Component {
  constructor (props) {
    super(props)

    this.state = {
      error: null,
      info: null
    }
  }

  componentDidCatch(error, info) {
    this.setState({
      error,
      info
    })
    console.error('ErrorsHandler.js - componentDidCatch() - error:', error)
    console.error('ErrorsHandler.js - componentDidCatch() - info:', info)
  }

  render() {
    // Close menu
    document.body.classList.remove('js-search-opened')
    document.body.classList.remove('js-menu-opened')

    if (this.state.error) {
      return (
        <Page title='Information'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <h3 className='b-info-subtitle'>Error</h3>
            <code>{this.state.error.toString()}</code>
            <h3 className='b-info-subtitle'>Info</h3>
            <code>{this.state.info.componentStack.toString()}</code>
          </article>
        </Page>
      )
    }

    return this.props.children
  }
}

ErrorsHandler.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
}

export default ErrorsHandler



// WEBPACK FOOTER //
// ./src/components/ErrorsHandler.js